import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { User } from '../_models/user';
import { APPCONFIG } from '../config';
import { EasyMarineHttpClient } from '../_utils/easy-marine-http-client';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthenticationService {
    url: string = APPCONFIG.apiHost;
    constructor(private http: EasyMarineHttpClient) {
    }

    login(username: string, password: string) {
        this.logout();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Client': 'EasyAdmin' });
        return this.http.post(this.url + '/user/authenticate', { username, password }, { headers })
            .map((response: any) => {
                // login successful if there's a jwt token in the response
                const user: User = response.data.user;
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.setItem('refreshToken', user.refreshToken)
                }
                return user;
            });
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_services/authentication.service.ts